import React, { FC, useMemo, useEffect } from 'react';
import { useQuery } from '@apollo/client';
import { useDrawerSearchFilterNameOrCategory, useDrawerFiltersCounts, useDrawerGlobalLoader } from '@minecraft.drawer';
import ErrorMessage from '@minecraft.error-message';
import { SEARCH_ROSTER_LISTS } from '../../../FilterBasic/FilterBasicCollection/FilterBasicCollectionGraphQL';
import { FiltersNameEnum } from '../../../shared/types';
import { generateSelectOptionsBasedOnField } from '../../../shared/utils';
import { FormItem } from '../../../shared/styles';
import { FilterDrawerType, FiltersCategoryNameEnum, FiltersCountNameEnum } from '../../shared/types';
import { useFiltersLabel } from '../../shared/hooks/useFiltersLabel';
import { RosterLists } from '../../FilterDrawerCollection';

interface Props {
  type: FilterDrawerType;
}

const RosterListsCategory: FC<Props> = ({ type }) => {
  const filtersLabelOfAudience = useFiltersLabel(type);

  const { data, error, loading } = useQuery(SEARCH_ROSTER_LISTS);
  const { isCategoryMatchedSearch, assignOptionsToCategoryFilters } = useDrawerSearchFilterNameOrCategory(
    FiltersCategoryNameEnum.rosterLists
  );
  const { filtersCounts } = useDrawerFiltersCounts();

  const rosterListsOptions = useMemo(() => {
    return generateSelectOptionsBasedOnField(
      data?.getOrganizationProfileLists?.objects,
      'name',
      false,
      filtersCounts?.[FiltersCountNameEnum.profileListIds]
    );
  }, [data]);

  useDrawerGlobalLoader(loading);

  useEffect(() => {
    if (rosterListsOptions.length > 0) {
      assignOptionsToCategoryFilters({
        [FiltersNameEnum.profileListIds]: rosterListsOptions,
      });
    }
  }, [rosterListsOptions]);

  if (error) {
    return <ErrorMessage error={error} />;
  }

  return (
    isCategoryMatchedSearch && (
      <FormItem $fullWidth $marginValue={2}>
        <RosterLists
          name={FiltersNameEnum.profileListIds}
          label={filtersLabelOfAudience[FiltersNameEnum.profileListIds]}
        />
      </FormItem>
    )
  );
};

export default RosterListsCategory;
